var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { SurveyElementBase, ReactElementFactory, Popup, attachKey2click } from "survey-react-ui";
var SideBarPropertyGridHeader = /** @class */ (function (_super) {
    __extends(SideBarPropertyGridHeader, _super);
    function SideBarPropertyGridHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(SideBarPropertyGridHeader.prototype, "objectSelectionAction", {
        get: function () {
            return this.props.model;
        },
        enumerable: false,
        configurable: true
    });
    SideBarPropertyGridHeader.prototype.getStateElement = function () {
        return this.objectSelectionAction;
    };
    SideBarPropertyGridHeader.prototype.renderElement = function () {
        var _this = this;
        var button = attachKey2click(React.createElement("div", { className: this.objectSelectionAction.buttonClassName, onClick: function () { return _this.objectSelectionAction.action(); } },
            React.createElement("div", { className: "svc-sidebar__header-caption" },
                React.createElement("span", { className: "svc-sidebar__header-title" }, this.objectSelectionAction.title),
                React.createElement("span", { className: "svc-sidebar__header-subtitle" }, this.objectSelectionAction.tooltip))), this.props.model);
        return (React.createElement("div", { className: "svc-sidebar__header svc-sidebar__header--tabbed" },
            React.createElement("div", { className: "svc-sidebar__header-container svc-sidebar__header-container--with-subtitle" },
                React.createElement("div", { className: "svc-sidebar__header-content" },
                    button,
                    React.createElement(Popup, { model: this.objectSelectionAction.popupModel })))));
    };
    return SideBarPropertyGridHeader;
}(SurveyElementBase));
ReactElementFactory.Instance.registerElement("svc-side-bar-property-grid-header", function (props) {
    return React.createElement(SideBarPropertyGridHeader, props);
});
